import { featuredBanners } from "@/mocks/manga";

export default function FeaturedSection() {
  return (
    <section id="featured" className="w-full bg-background-950">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium uppercase tracking-widest text-secondary-400">
              <i className="ri-medal-line"></i> FEATURED
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-4xl">编辑精选 · 必读推荐</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-100/80">
              由编辑部精心挑选的年度口碑之作，适合一口气读完的高质量火影同人漫画。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          {featuredBanners.map((b, idx) => (
            <a
              key={b.title}
              href="#update"
              className={`group relative flex min-h-[260px] flex-col justify-end overflow-hidden rounded-lg ${idx === 0 ? "lg:col-span-1" : ""}`}
            >
              <img src={b.cover} alt={`${b.title} - 火影同人漫画推荐横幅`} className="absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/40 to-transparent"></div>
              <div className="relative z-10 p-6 md:p-7">
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  <i className="ri-fire-line"></i> 必读推荐
                </span>
                <h3 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-2xl">{b.title}</h3>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-background-100/85">{b.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-secondary-400">
                  前往阅读 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}